<template>
  <div class="video-sprite-setting">
    <div class="exceeded-tip" ref="tipRef" v-show="tipShow" @mousedown.stop>
      <span>您添加的视频已超出了当前页面的时长。点击“增加”可呈现剩余的视频。</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data () {
    return {
      tipShow: false,
      sceneDur: 0,
      sceneOldDur: 0,
      videoAdding: {
        type: '',
        data: ''
      }
    };
  },
  computed: {
    ...mapGetters([
      'TOOL',
      'SelectScenes_Msg',
      'SelectSprites_Msg',
      'SpriteOperation',
      'SpriteBeforeSwap',
      'BgOperation'
    ])
  },
  watch: {
    'TOOL.sprites' (val, oldVal) {
      const $playerVideos = this.TOOL.player.ele.find('.video-sprite-video');
      $playerVideos.each((i, el) => {
        el && !el.paused && el.pause();
        el && el.onTimeUpdateVue && el.removeEventListener('timeupdate', el.onTimeUpdateVue);
        el && el.onPause && el.removeEventListener('pause', el.onPause);
      });
    }
  },
  created () {
    this.$bus.on('timeline_play_all', (data) => {
      let { nowTime, isPlay } = data;
      // eve('timeline_play_all', null, data);

      this.onPlayAll(data);
    });

    // this.$bus.on('preview_mousedown', () => {
    //   this.onPlayAll({isPlay: false});
    // });
    this.$bus.on('preview_mouseup', () => {
      this.onPlayAll({isPlay: false});
      setTimeout(() => {
        this.onPlayAll({isPlay: true});
      });
    });

    this.$bus.on('confirmAddVideo', (action) => {
      //console.log('confirmAddVideo' ,action);
      this.addVideo(action)
    });
    this.$bus.on('confirmAddVideo.goOn', (action) => {
      const vm = this;
      if (action === 'add') {
        vm.addVideoHard(vm.videoAdding);
      }
    });
    this.$bus.on('pasteVideo', (option) => {
      this.addVideoHard({data: option, type: 'sprite'});
    });

    this.$bus.on('setCutDuration.done', () => {
      this.checkExceeded();
    });

    this.$bus.on('record_close_before', () => {
      let d = this.SelectScenes_Msg.duration / 1000;
      // eve('playByFrame', null, this.SelectScenes_Msg.nowTime, this.SelectScenes_Msg.id);
      this.TOOL.eve.emit('play_' + this.SelectScenes_Msg.id, this.SelectScenes_Msg.nowTime);
    });

    // 时间抽停留时长与视频素材截取时长
    /* this.$watch(function () {
      return this.SelectScenes_Msg && this.SelectScenes_Msg.duration;
    }, function (val, oldVal) {
      if (oldVal > val) {
        return;
      }

      let scene = this.SelectScenes_Msg;
      let videoSprites = scene.sprites.filter(sprite => sprite.type === 'Video') || [];
      let sceneDur = this.sceneDur = val / 1000;
      let sceneOldDur = this.sceneOldDur = oldVal / 1000;

      videoSprites.map(sprite => {
        let videoProps = sprite.video;
        if (
          sceneDur - videoProps.startOffset > videoProps.cutDuration
          && videoProps.endOffset === sceneDur
        ) {
          sprite.setCutDuration({
            cutDuration: sceneDur - videoProps.startOffset
          });
        }
      })
    });

    this.$bus.on('changeTotalTime', data => {
      let scene = this.SelectScenes_Msg;
      let videoSprites = scene.sprites.filter(sprite => sprite.type === 'Video') || [];

      let sceneDur = scene.getDuration() / 1000;
      videoSprites.map(sprite => {
        if (data.val < 1 && sprite.video.cutDuration > sceneDur - 1 - sprite.video.startOffset) {
          let delta = sprite.video.cutDuration - (sceneDur - 1 - sprite.video.startOffset)
          sprite.setCutDuration({
            cutDuration: sprite.video.cutDuration - delta
          })
        }
      })
    }); */
  },
  methods: {
    onPlayAll (data) {
      const vm = this;
      const $playerVideos = this.TOOL.player.ele.find('.video-sprite-video');
      let sceneSecTop;
      // this.showingSceneId = '';

      const handler = (frame, scenesId) => {
        sceneSecTop = (frame || 0) / vm.TOOL.option.frameRate;
        // if (this.showingSceneId === scenesId) {
        //   return;
        // }

        if (vm.currSceneId !== scenesId) {
          pauseAll();
          vm.currSceneId = scenesId;
          vm.currSpriteLeave = false;
        }

        let currScene = vm.TOOL.getScenesIdData(scenesId);
        let currSprite = (currScene.sprites.filter(s => s.type === 'Video') || [])[0];
        if (!currSprite) {
          return;
        }
        let currSceneP = vm.TOOL.player.scenesDict[scenesId];
        let currVideoP = currSceneP.eleC.find('.video-sprite-video')[0]; // player 层的视频

        let startTime = currSprite.video.startTime || 0;
        let endTime = currSprite.video.startTime + currSprite.video.cutDuration || 0.5;

        let vInfo = currSprite.video;

        if (data.isPlay && !vm.currSpriteLeave && currVideoP.currentTime <= vInfo.startTime + vInfo.cutDuration * vInfo.repeatTimes - 0.5) {
          // this.showingSceneId = scenesId;
          play(currVideoP, currSprite, (frame || 0) / vm.TOOL.option.frameRate, startTime, endTime);
        }
      };

      if (!this.playHandler) {
        this.playHandler = handler;
      }

      if (data.isPlay) {
        vm.currSceneId = null;
        vm.currSpriteLeave = false;
        clearInterval(vm.tid);
        this.isVideoPlay = this.TOOL.isVideoSpritePlay = true;
        this.TOOL.eve.on('playByFrame', this.playHandler);
      } else {
        vm.TOOL.sprites.forEach(scene => {
          scene.sprites.forEach(sprite => {
            if (sprite.videoTid) {
              clearInterval(sprite.videoTid);
            }
          });
        });

        this.playHandler && this.TOOL.eve.off('playByFrame', this.playHandler);
        pauseAll.call(this);

        // 保证全部视频停止播放
        clearInterval(vm.tid);
        /* vm.tidCount = 0
        vm.tid = setInterval(() => {
          $('video').each((i, el) => {
            if (el && !el.paused) {
              el.pause()
            }
          })
          eve.off('playByFrame', this.playHandler);
          vm.tidCount += 1;
          if (vm.tidCount >= 2) {
            clearInterval(vm.tid);
          }
        }, 100); */
        this.isVideoPlay = this.TOOL.isVideoSpritePlay = false;
      }

      function play (video, sprite, sec, startTime, endTime) {
        if (!video) {
          return;
        }
        let isPlaying = video.currentTime >= 0 &&
          !video.paused && !video.ended &&
          video.readyState > 2;

        if (video && !isPlaying && video.paused) {
          let scenePlayTime = sec || data.time || 0;
          let videoSec = sprite.getVideoSec(sec);
          video.currentTime = videoSec;

          // sprite.video.volume
          $(video).prop('volume', sprite.video.volume > 1 ? sprite.video.volume / 100 : sprite.video.volume);

          // eve.off('playByFrame', vm.playHandler);
          intervalCheck(sprite, video, scenePlayTime);
        }
      }

      function pauseAll () {
        const $playerVideos = vm.TOOL.player.ele.find('.video-sprite-video');
        $playerVideos.each((index, el) => {
          el && !el.paused && el.pause();
          el && el.removeEventListener('timeupdate', (el || {}).onTimeUpdateVue);
          el && el.removeEventListener('pause', (el || {}).onPause);
        });
      }

      function intervalCheck (sprite, videoEleP, sceneSec) {
        let isPlaying = videoEleP.currentTime >= 0 &&
          !videoEleP.paused && !videoEleP.ended &&
          videoEleP.readyState > 2;

        // 处理循环
        videoEleP.onTimeUpdateVue = videoEleP.onTimeUpdateVue || handleSec;

        let videoInfo = sprite.video;
        // let sec = videoEleP.currentTime;
        // console.log({sec})
        // if (sec >= videoInfo.startTime && sec <= videoInfo.startTime + videoInfo.cutDuration * videoInfo.repeatTimes - 0.5 && !isPlaying) {
        if (sceneSecTop >= videoInfo.startOffset && sceneSecTop < videoInfo.startOffset + videoInfo.cutDuration) {
          vm.TOOL.eve.off('playByFrame', vm.playHandler);
          videoEleP.currentTime = sprite.getVideoSec(sceneSecTop);
          vm.timeMark = Date.now();
          videoEleP.play()
            .then(() => {
              // videoInfo.stage = 'playing';
              videoInfo.currRepeat = Math.max(sceneSecTop - videoInfo.startOffset, 0) / videoInfo.cutDuration | 0;
              console.log({currRepeat: videoInfo.currRepeat});
              videoEleP.removeEventListener('timeupdate', videoEleP.onTimeUpdateVue);
              videoEleP.addEventListener('timeupdate', videoEleP.onTimeUpdateVue);
              vm.TOOL.eve.on('playByFrame', vm.playHandler);
            })
            .catch(err => {
              vm.TOOL.eve.on('playByFrame', vm.playHandler);
              console.log({err});
              videoEleP.pause();
            });
        } else if (sceneSecTop < videoInfo.startOffset) {
          videoEleP.currentTime = videoInfo.startTime;
          videoEleP.paused || videoEleP.pause();
        } else {
          clearInterval(sprite.videoTid);
        }

        // handleSec();

        // 处理循环播放
        function handleSec () {
          let video = videoEleP;
          let videoInfo = sprite.video;
          let videoSec = video.currentTime;
          if (vm.timeMark) {
            let diff = (Date.now() - vm.timeMark) / 1000;
            videoSec += diff;
            vm.timeMark = 0;
          }

          // 素材退场了
          // console.log([sceneSecTop, videoInfo.endOffset])
          if (sceneSecTop >= videoInfo.endOffset) {
            videoSec = sprite.getVideoSec(sceneSecTop);
            vm.currSpriteLeave = true;
            videoEleP.pause();
            videoEleP.currentTime = videoSec;
            return;
          }

          if (videoInfo.loop) {
            if (videoSec >= videoInfo.cutDuration + videoInfo.startTime - 0.1) {
              videoSec = videoInfo.startTime;
              setCurr(video, videoSec);
            }
          } else if (videoInfo.repeatTimes === 1) {
            // console.log({d: videoSec >= videoInfo.cutDuration + videoInfo.startTime })
            if (videoSec >= videoInfo.cutDuration + videoInfo.startTime) {
              video.pause();
              videoSec = videoInfo.cutDuration + videoInfo.startTime;
              setCurr(video, videoSec);
              // videoInfo.stage = 'after';
              return;
            }
          } else if (videoInfo.repeatTimes > 1) {
            if (videoInfo.currRepeat >= videoInfo.repeatTimes) {
              video.pause();
              videoSec = videoInfo.cutDuration + videoInfo.startTime;
              setCurr(video, videoSec);
              // videoInfo.stage = 'pause';
              return;
            } else if (videoSec >= videoInfo.cutDuration + videoInfo.startTime) {
              if (sceneSecTop >= videoInfo.endOffset) {
                vm.currSpriteLeave = true;
                videoEleP.pause();
                return;
              }
              videoSec = videoInfo.startTime;
              videoInfo.currRepeat += 1;
            }
          }

          if (videoSec !== video.currentTime) {
            video.currentTime = videoSec;
          }
        }

        function setCurr (video, sec) {
          video.currentTime = sec;
        }
      }
    },
    addVideo ({type, data} = {}) {
      this.videoAdding = {
        type,
        data
      };
      if (this.videoExist()) {
        this.$modal.show('confirmAddVideo', {
          action: 'add'
        });
        return;
      }

      this.addVideoHard({type, data});
    },
    addVideoHard ({type, data} = {}) {
      if (type === 'bg') {
        this.$bus.emit('judgeItemPayType_vue', {
          type: 'bg',
          id: ('BG-' + this.SelectScenes_Msg.id),
          option: {
            resourceId: data.id, // 背景资源id
            fileType: data.fileType // 背景资源type
          },
          opHelper: {
            isSvip: false
          },
          scenesId: this.SelectScenes_Msg.id
        });
      }
      this.$store.commit('del_vipSprites', {id: 'BG-' + this.SelectScenes_Msg.id});

      if (this.SpriteOperation === 'swap' && type === 'sprite') {
        let sprite = this.SelectSprites_Msg[0] || this.SpriteBeforeSwap;
        let optionForAdd = {
          url: data.url,
          resourceId: data.id, // 资源id
          fileType: isNaN(data.fileType) ? null : data.fileType,
          thumbnailUrl: data.thumbnailUrl,
          video: {
            ...sprite.video,
            startTime: 0,
            cutDuration: void 0,
            volume: 50,
            poster: data.thumbnailUrl,
            loop: sprite.isLoop == null ? (sprite.video || {}).loop : sprite.isLoop,
            repeatTimes: sprite.numberOfLoops || (sprite.video || {}).repeatTimes
          }
        };

        this.TOOL.addVideo(type, optionForAdd, true, sprite);

        return;
      }

      if (this.BgOperation === 'swap' && type === 'bg') {
        let sceneBgProps = this.SelectScenes_Msg.background;
        let bgOpts = {...data};
        bgOpts.data = {
          ...sceneBgProps.data.data,
          url: data.url
        };
        bgOpts.zoomActive = sceneBgProps.zoomActive;
        bgOpts.zoomOptions = sceneBgProps.zoomOptions;
        bgOpts.laying = 'fit';
        bgOpts.isSwap = true;
        this.TOOL.addVideo(type, bgOpts, true);

        // 关闭替换素材遮罩
        this.$store.commit('save_BgOperation', 'add');
        return;
      }

      if (this.SpriteOperation === 'swap' || this.BgOperation === 'swap') {
        return;
      }
      this.TOOL.addVideo(type, data, true)
        .then((sprite, type) => {
          type === 'sprite' && this.TOOL.selectSprite([sprite]);
        });
    },
    addVideoSprite (data) {

    },
    addVideoBg (data) {

    },
    videoExist () {
      let scene = this.TOOL.selectedScenes;
      let sprites = scene.sprites || [];
      let bgType = scene.background.data.type;
      let videoBgExist = bgType === 'Video';
      let videoSpriteExist = (sprites.filter(s => s.type === 'Video') || []).length;
      let ret = videoBgExist || videoSpriteExist;

      return ret;
    },

    /**
     *
     * @reutrns {Object}
     */
    checkExceeded (val) {
      val = val || this.SelectScenes_Msg.sprites;
      if (!val) {
        return;
      }
      // console.log({val})
      let videoSprite = (val.filter(s => s.type === 'Video') || [])[0];
      if (!videoSprite) {
        return;
      }
      let isShow = videoSprite.ele.css('display') !== 'none' && videoSprite.helpEle.css('display') !== 'none';
      if (!isShow) {
        return;
      }
      let videoProps = videoSprite.video;
      let sceneDur = this.SelectScenes_Msg.duration / 1000;
      let exceededScene = sceneDur - videoProps.startOffset <= videoProps.endOffset - videoProps.startOffset &&
        videoProps.cutDuration > sceneDur - videoProps.startOffset;
      let exceededStay = sceneDur - videoProps.startOffset > videoProps.endOffset - videoProps.startOffset &&
        videoProps.cutDuration > videoProps.endOffset - videoProps.startOffset;

      if (exceededScene) {
        this.showTip();
        clearTimeout(this.tid);
        this.tid = setTimeout(() => {
          $('body').one('mousedown', () => {
            this.tipShow = false;
          });
        }, 1000);
      }
      return {
        exceededScene, // 截取时长是否超出当前场景时长
        exceededStay, // 截取时长是否超出素材停留时长
        videoSprite
      };
    },
    longerStayTime () {
      let {
        exceededScene,
        exceededStay,
        videoSprite
      } = this.checkExceeded() || {};
      let videoProps = videoSprite.video;
      if (exceededStay && !exceededScene) {
        videoSprite.updateEffect({
          exitAnim: {
            end: (videoProps.startOffset + videoProps.cutDuration) * 1000
          }
        });
      }
    },
    showTip () {
      let btnRect = $('.time-line-button')[0].getBoundingClientRect();
      let l = btnRect.left + btnRect.width / 2 - 198 / 2;
      let t = btnRect.top - 106 - 8;
      let el = this.$refs.tipRef;
      el.style.left = l + 'px';
      el.style.top = t + 'px';
      this.tipShow = true;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../style/_triangle.scss";

.video-sprite-setting {
  position: relative;
}
.exceeded-tip {
  // display: none;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 198px;
  height: 106px;
  padding: 0 1.2em;
  color: #fff;
  line-height: 1.5;
  background-color: rgba(#000, .7);
  border-radius: 8px;

  &:after {
    @include triangle(bottom, 8px, 8px, rgba(#000, .7));
    content: " ";
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translatex(-50%);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/emodal/videoSprite/setting.vue